exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-menu__content[data-v-a7513678] {\r\n  position: absolute !important;\n}\r\n", ""]);

// exports
